/**
 * Newly created attributes need an identity inside the editable client model
 * before the catalog is persisted. These tokens are intentionally temporary:
 * the service replaces them with a stable ATTR_… code during save.
 */
export const AUTO_ATTRIBUTE_CODE_PREFIX = 'AUTO_ATTR_';

const normalize = (value: string | null | undefined): string => (
  value?.trim().toUpperCase() ?? ''
);

export const isAutoAttributeCode = (value: string | null | undefined): boolean => (
  new RegExp(`^${AUTO_ATTRIBUTE_CODE_PREFIX}\\d+$`).test(normalize(value))
);

export const createAutoAttributeCode = (existingCodes: readonly string[]): string => {
  const usedCodes = new Set(existingCodes.map(normalize));
  let sequence = 1;
  let candidate = `${AUTO_ATTRIBUTE_CODE_PREFIX}${sequence}`;
  while (usedCodes.has(candidate)) {
    sequence += 1;
    candidate = `${AUTO_ATTRIBUTE_CODE_PREFIX}${sequence}`;
  }
  return candidate;
};

export const displayAttributeCode = (value: string | null | undefined): string => {
  const code = value?.trim() ?? '';
  if (!code || isAutoAttributeCode(code)) return '保存后系统生成';
  return code;
};

export const formatAttributeOptionLabel = (
  name: string | null | undefined,
  code: string | null | undefined,
): string => `${name?.trim() || '未命名'} (${displayAttributeCode(code)})`;
